import { ProviderErrorResponse } from '../apis/errors.js';

/** Default retry budget for transient failures (matches TanStack's default). */
const MAX_RETRIES = 3;

/**
 * TanStack Query `retry` predicate: keep retrying transient failures (network
 * blips, 5xx) up to {@link MAX_RETRIES}, but surface a **provider-disconnect**
 * error immediately — a dead Genba/Trusstor session won't recover by retrying,
 * so retrying it only delays the "data unavailable" state by the backoff window.
 */
export function retryUnlessProviderError(failureCount: number, error: unknown): boolean {
  if (error instanceof ProviderErrorResponse) return false;
  return failureCount < MAX_RETRIES;
}
